// The event API represents a SQL NULL deadline as DateTime.MinValue.
// Accept both serialized API values and the Date values declared by legacy event types.
export function hasEventRsvpDeadlinePassed(deadline: string | Date | null | undefined, now = new Date()): boolean {
	if (!deadline || (typeof deadline === 'string' && deadline.startsWith('0001-01-01'))) return false;
	const date = deadline instanceof Date ? deadline : new Date(deadline);
	return date.getUTCFullYear() > 1 && date < now;
}
